import { getCookie } from '@share/utils/index'
import JSONBig from 'json-bigint'
import zhHK from '@yuewen/reader/locales/zhHK'
import type { PageContext } from '@root/types'

export const getDDLUrl = (options: { [key: string]: string }): string => {
  // 矩阵站：DDL 来源标识统一为 qidianPC（矩阵站属于 PC 矩阵），
  // 不再依据 hostname 是否含 qdmm 做女频分支
  const defaultSource = 'qidianPC'
  const host = `https://${
    import.meta.env.VITE_ENV_TYPE === 'oa' ? 'oa' : ''
  }qidian.gtimg.com`
  const au = `QDReader/app/${options.method}`
  const obj: { [key: string]: string } = {
    query: options.query || JSON.stringify({}),
    page: options.page || 'qidian-pc',
    source: options.source || defaultSource,
    reuId: options.uuid || '',
  }
  const queryList: string[] = []
  Object.keys(obj).forEach((name) => {
    queryList.push(`${name}=${encodeURIComponent(obj[name])}`)
  })
  return `${host}/${au}?${queryList.join('&')}&__self_redirect__=1`
}
export const transformChineseBase = (
  pageContext?: PageContext<unknown, unknown>,
) => {
  return <U>(message: U): U => {
    const isHk =
      getCookie(
        'lang',
        pageContext && pageContext.headers?.cookie
          ? pageContext.headers?.cookie
          : '',
      ) === 'zht'
    if (isHk) {
      const messageString = JSONBig.stringify(message)
      return JSONBig.parse(zhHK._trans.trans(messageString)) as U
    }
    return message
  }
}

export const getBookDetailUrl = (
  bookId: number | string,
  _hostIsMM?: boolean,
): string => {
  // 矩阵站：书详情统一回起点 PC 站（qidian.com），不再做 qdmm 分支
  return `//${
    import.meta.env.VITE_ENV_TYPE === 'pro' ? '' : import.meta.env.VITE_ENV_TYPE
  }www.qidian.com/book/${bookId}/`
}
